import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showMessage } from '../../redux/actions/common-message/message-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import {
  CardContainer,
  ADD_ICON_IMAGE,
  ADD_CARD_TEXT,
  Header,
  ACC_IMAGE,
  SavedCardListWrapper
} from '../../screens/manage-payment/manage-payment.style';
import { CARD_ICON } from '../../utils/constants';
import toUpper from 'lodash/toUpper';
import { getUSBankIcon } from '../../utils/templates/payment-method';
import { isEuCorridor } from '../../utils/library';
import InfoBanner from './InfoBanner';
import COLORS from '../../common/styles/color-pallete';
import { DELETE_ICON } from '@Images';
import {
  EVENT_ROUTE_KEYS,
  EventItemSection,
  EventNamesV2,
  FLOW_TYPE
} from '@Utils/events/eventsConstants';
import { logEventV2 } from '@Utils/events/logUserEvents';

class SavedCardList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleDelete = (item, index) => {
    const { card_brand, card_number, card_type } = item;
    const eventProperty = {
      section: EventItemSection.LIST,
      pageName: EVENT_ROUTE_KEYS.ManagePaymentOptions,
      ctaName: 'Delete Initiated',
      card_brand,
      card_number,
      card_type,
      position: index + 1,
      flowType: FLOW_TYPE.MANAGE_PAYMENT_OPTIONS
    };
    logEventV2(EventNamesV2.ITEM_CLICKED, eventProperty);
    this.props.deleteCard(item);
  };

  render() {
    const { data, type, card } = this.props;
    const showCardList = data && data.length > 0;
    const showDebitCardBannerFlag = isEuCorridor(this.props.user_session?.country_code);

    return (
      <SavedCardListWrapper>
        {showCardList && (
          <>
            <Header
              fontSize={'18px'}
              paddingTop={'20px'}
              paddingBottom={'10px'}
              className="text-align-left"
              id="save-debit-card-header"
            >
              {card.heading}
            </Header>
            {showDebitCardBannerFlag && <InfoBanner />}
          </>
        )}
        {data &&
          data.map((item, index) => {
            return (
              <CardContainer
                className="saved-cards"
                key={index}
                marginTop={'20px'}
                id="saved-debit-card-container"
              >
                {type === 'CARD' ? (
                  <ADD_ICON_IMAGE
                    $padding="0px"
                    height="50px"
                    src={CARD_ICON[toUpper(item.card_brand)]}
                    id="saved-debit-card-icon"
                  />
                ) : (
                  <ACC_IMAGE>
                    <img src={getUSBankIcon(item.card_brand)} id="saved-account-icon" alt="card" />
                  </ACC_IMAGE>
                )}
                <ADD_CARD_TEXT id={`saved-debit-card-${item.card_number}`}>
                  <span id={`saved-debit-card-default-text-${item.card_number}`} className="title">
                    {card?.cardHeader ? card.cardHeader(item.card_type) : item.card_brand}
                  </span>
                  <span
                    id={`saved-debit-card-default-card-number-${item.card_number}`}
                    style={{
                      color: COLORS.textLightGrey,
                      paddingTop: '7px',
                      fontSize: '14px'
                    }}
                  >
                    {item.card_number}
                  </span>
                </ADD_CARD_TEXT>
                <ADD_ICON_IMAGE
                  id={'delete-icons'}
                  $padding={'0px'}
                  style={{ marginLeft: 'auto' }}
                  src={DELETE_ICON}
                  onClick={() => this.handleDelete(item, index)}
                />
              </CardContainer>
            );
          })}
      </SavedCardListWrapper>
    );
  }
}

SavedCardList.propTypes = {
  data: PropTypes.array,
  deleteCard: PropTypes.func,
  isMobile: PropTypes.bool,
  type: PropTypes.string,
  card: PropTypes.object,
  user_session: PropTypes.object
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userSessionReducer: { user_session }
    }
  } = reduxState;
  return {
    user_session
  };
}

export default connect(mapStateToProps, {
  showMessage,
  activateLoader,
  disableLoader
})(SavedCardList);
